import { User } from '@/types/user';

export type FootballRouteId = 'players' | 'scouting' | 'comparison' | 'team' | 'reports' | 'matches' | 'calendar' | 'season' | 'league';

export const FOOTBALL_ROUTE_POLICY: Record<FootballRouteId, readonly User['role'][]> = {
  players: ['admin', 'manager', 'coach', 'medical'],
  scouting: ['admin', 'manager', 'coach', 'scout', 'medical'],
  comparison: ['admin', 'manager'],
  team: ['admin', 'manager'],
  reports: ['admin', 'manager', 'coach', 'scout', 'medical'],
  matches: ['admin', 'manager', 'coach', 'medical'],
  calendar: ['admin', 'manager', 'coach', 'medical'],
  season: ['admin', 'manager', 'coach'],
  league: ['admin', 'manager', 'coach', 'medical'],
};

export const canAccessFootballRoute = (role: User['role'], id: FootballRouteId): boolean => (
  FOOTBALL_ROUTE_POLICY[id].includes(role)
);

export const getPermittedFootballRoutes = (role: User['role']): FootballRouteId[] => (
  (Object.keys(FOOTBALL_ROUTE_POLICY) as FootballRouteId[]).filter(id => canAccessFootballRoute(role, id))
);
